import {
  Box,
  Breakpoint,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
} from "@mui/material";
import { FC, ReactNode } from "react";

type UtilitaireModalProps = {
  onClose?: () => void;
  renderButtons: () => ReactNode;
  onSubmit: () => void;
  title: string;
  children: ReactNode;
  maxWidth?: false | Breakpoint | undefined;
};

export const UtilitaireModal: FC<UtilitaireModalProps> = ({
  title,
  onClose,
  renderButtons,
  onSubmit,
  maxWidth = "sm",
  children,
}) => {
  return (
    <form onSubmit={onSubmit}>
      <Dialog maxWidth={maxWidth} fullWidth open={true}>
        <DialogTitle>{title}</DialogTitle>
        <Divider />
        <DialogContent
          sx={{
            backgroundColor: (t) => t.palette.background.default,
            padding: "1.5rem !important",
          }}
        >
          {children}
        </DialogContent>
        <DialogActions>
          <Box
            sx={{ marginTop: 0, marginLeft: "auto" }}
            display="flex"
            justifyContent="end"
          >
            {renderButtons()}
          </Box>
        </DialogActions>
      </Dialog>
    </form>
  );
};
